import { isNumber } from "lodash";

const isFloat = (value) => isNumber(value) && value % 1 !== 0;

export { isFloat };
